/**
 * Tipo do banner do modal de depósito (ENG-838): `deposit-sem-ftd` para quem nunca
 * depositou, `deposit-com-ftd` para quem já depositou. Cada tipo é uma slug pública
 * própria no backoffice (ver `MODAL_SLUG_MAP` em `stores/apostatudo/modal-banners.ts`),
 * então a decisão por usuário fica aqui e o cache das rotas continua compartilhado.
 *
 * FTD vem de duas fontes da Cactus, e basta uma delas: `has_transactions` da carteira
 * (atualizada pelo `updateWallet()` logo após o depósito) e `ftd_value` do perfil (que
 * não é rebuscado após o depósito, mas já vem certo no carregamento). FTD nunca volta
 * a false, então o OR não tem como errar para o lado do "com FTD".
 *
 * `null` enquanto a carteira não foi buscada: `hasWalletDeposit` começa false e, sem
 * esperar, quem já depositou veria o banner de sem FTD até a carteira chegar. Lê o
 * `realWallet` direto em vez do `walletHasFirstDeposit`, que também vira false durante
 * cada refetch e faria o banner piscar.
 */
export const useDepositBannerType = () => {
  const { realWallet, hasLoadedWallet } = storeToRefs(useWalletStore());
  const { hasFirstDeposit } = useUserData();

  const depositBannerType = computed<
    'deposit-sem-ftd' | 'deposit-com-ftd' | null
  >(() => {
    if (hasFirstDeposit.value || realWallet.value.hasWalletDeposit) {
      return 'deposit-com-ftd';
    }

    if (!hasLoadedWallet.value) return null;

    return 'deposit-sem-ftd';
  });

  return { depositBannerType };
};
